import { render, staticRenderFns } from "./socialCaptcha.vue?vue&type=template&id=05aa8031&scoped=true&"
import script from "./socialCaptcha.vue?vue&type=script&lang=js&"
export * from "./socialCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./socialCaptcha.vue?vue&type=style&index=0&id=05aa8031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa8031",
  null
  
)

export default component.exports